import api from "src/apis/api"

// ── Channel partners (CRM, admin/sourcing side) ──────────────────────────────
export async function fetchChannelPartners({ page = 1, per_page = 20, q = "", status = "" } = {}) {
  const params = new URLSearchParams({ page, per_page })
  if (q) params.set("q", q)
  if (status) params.set("status", status)
  const { data } = await api.get(`/api/v1/channel_partners?${params}`)
  return data // { channel_partners, meta }
}

export async function fetchChannelPartner(id) {
  const { data } = await api.get(`/api/v1/channel_partners/${id}`)
  return data.channel_partner
}

export async function createChannelPartner(payload) {
  const { data } = await api.post("/api/v1/channel_partners", { channel_partner: payload })
  return data.channel_partner
}

export async function updateChannelPartner(id, payload) {
  const { data } = await api.patch(`/api/v1/channel_partners/${id}`, { channel_partner: payload })
  return data.channel_partner
}

export async function deactivateChannelPartner(id) {
  const { data } = await api.delete(`/api/v1/channel_partners/${id}`)
  return data
}


// ── Performance (sourcing-manager dashboard) ─────────────────────────────────
export async function fetchChannelPartnerPerformance({ from = "", to = "", project_id = "" } = {}) {
  const params = new URLSearchParams()
  if (from) params.set("from", from)
  if (to) params.set("to", to)
  if (project_id) params.set("project_id", project_id)
  const { data } = await api.get(`/api/v1/channel_partners/performance?${params}`)
  return data // { rows, totals }
}

// Lightweight picker for the LeadForm: active CPs (+ their enrollments).
export async function fetchChannelPartnersForPicker(q = "") {
  const params = new URLSearchParams()
  if (q) params.set("q", q)
  const { data } = await api.get(`/api/v1/channel_partners/picker?${params}`)
  return data.channel_partners
}
